import { AttributeColumnEditor, AttributeDetailEditor } from '@leverege/ui-attributes';
import ObjectAttributeColumnModel from './objectRenderer/ObjectAttributeColumnModel.js';
import ObjectAttributeDetailModel from './objectRenderer/ObjectAttributeDetailModel.js';
import ObjectAtrributeColumnRenderer from "./objectRenderer/ObjectAttributeColumnRenderer.js";
import ObjectAttributeDetailRenderer from "./objectRenderer/ObjectAttributeDetailRenderer.js";
export default {
  install: molten => {
    molten.addPlugin('Model', {
      type: ObjectAttributeColumnModel.TYPE,
      model: ObjectAttributeColumnModel
    });
    molten.addPlugin('ModelEditor', {
      type: ObjectAttributeColumnModel.TYPE,
      editor: AttributeColumnEditor
    });
    molten.addPlugin('ColumnRenderer', {
      type: ObjectAttributeColumnModel.TYPE,
      renderer: ObjectAtrributeColumnRenderer
    });
    molten.addPlugin('Model', {
      type: ObjectAttributeDetailModel.TYPE,
      model: ObjectAttributeDetailModel
    });
    molten.addPlugin('ModelEditor', {
      type: ObjectAttributeDetailModel.TYPE,
      editor: AttributeDetailEditor
    });
    molten.addPlugin('DetailRenderer', {
      type: ObjectAttributeDetailModel.TYPE,
      renderer: ObjectAttributeDetailRenderer
    });
  }
};